import { log } from '@s4l/monitoring'
import { Component } from 'react'
import { report } from 'src/utils/clientErrorReporter'

interface ErrorBoundaryProps {
  children: React.ReactNode
  fallback?: React.ReactNode
}

interface ErrorBoundaryState {
  error: string
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: '' }
  }

  static getDerivedStateFromError(error: Error) {
    return { error: `${error.name}: ${error.message}` }
  }

  componentDidCatch(error: Error) {
    log.error({
      message: `Component render error caught by ErrorBoundary`,
      metadata: {
        error,
        userAgent: navigator?.userAgent ?? 'Unknown',
        href: window !== undefined ? window.location.href : 'Unknown',
        query: window !== undefined ? window.location.search : 'Unknown',
      },
    })

    report(`${error.name}: ${error.message}`)
  }

  render() {
    const { error } = this.state
    const { fallback } = this.props

    if (error) {
      return fallback ?? null
    }

    const { children } = this.props
    return children
  }
}

export default ErrorBoundary
